import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type GridSortModel } from '@mui/x-data-grid-premium';
import { type Organisation } from 'types/models';

export interface OrganisationsState extends EntityState<Organisation>, ActiveState {
   statistics?: any;
   sort: GridSortModel;
}

const store = createEntityStore<OrganisationsState>(
   {
      statistics: undefined,
      sort: [],
   },
   { resettable: true, name: 'organisations' }
);

export default store;
